<div class="audit-trail-header">
  <div class="audit-trail-header-left">
    <div class="audit-trail-icon-wrapper">
      <daz-icon [name]="'clock'" [size]="'22px'" [color]="'var(--hubtiger-primary)'"></daz-icon>
    </div>
    <div class="audit-trail-header-text">
      <div class="audit-trail-title">Audit Trail &mdash; #{{ jobcard?.jobCardNo }}</div>
      <div class="audit-trail-subtitle">
        {{ jobcard?.customer.Name }} {{ jobcard?.customer.Surname }} &middot; {{ auditEntries.length }} entries
      </div>
    </div>
  </div>
  <div class="audit-trail-header-actions">
    <hub-button [text]="'Print'"
                [icon]="'printer'"
                [style]="'secondary'"
                [size]="'xl'"
                (buttonClick)="print()">
    </hub-button>
    <hub-button [icon]="'cross'"
                [style]="'outline'"
                [size]="'xl'"
                (buttonClick)="activeModal.dismiss()">
    </hub-button>
  </div>
</div>

<div class="modal-content-container">
  <div class="audit-trail-list">
    <ng-container *ngFor="let group of groupedEntries">
      <div class="audit-date-header">{{ group.dateLabel }}</div>
      <ng-container *ngFor="let entry of group.entries; let last = last">
        <div class="audit-entry">
          <!--<span class="audit-entry-icon">{{ entry.icon }}</span>-->
          <div class="audit-entry-body">
            <div class="audit-entry-title">{{ entry.title }}</div>
            <div class="audit-entry-actor">{{ entry.actor }}</div>
            <div class="audit-entry-time">
              {{ entry.timestamp | DateFormatPipe: displayDateTimeFormat }} {{ formatEntryTime(entry.timestamp) }} &middot; {{ formatEntryDate(entry.timestamp) }}
            </div>
          </div>
        </div>
        <div *ngIf="!last" class="audit-entry-divider"></div>
      </ng-container>
    </ng-container>
    <div *ngIf="groupedEntries.length === 0" class="audit-empty-state">
      No audit entries found.
    </div>
  </div>
</div>

<div class="modal-footer-container">
  <div class="button-container">
    <hub-button [text]="'Close'"
                [style]="'outline'"
                [size]="'xl'"
                (buttonClick)="activeModal.dismiss()">
    </hub-button>
  </div>
</div>
